import React, { useCallback } from 'react';
import { Card, Heading, Spacer, TextButton } from '@zillow/constellation';
import * as S from './styles';
import { trackEvent } from 'app/shared/utils/analytics/trackEvent';
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';
import pathsManifest from 'app/shared/utils/pathsManifest';

interface SEOFooterProps {
  areaName: string;
  zipcodesInCity: Array<{ name: string; resourceId: string }>;
  nearbyAreas: Array<{ name: string; resourceId: string }>;
}

const Link: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<{ name: string; resourceId: string }>>
> = (props) => {
  const { name, resourceId } = props;
  const onClick = useCallback(() => {
    trackEvent({ ...gaEvents.CLICK_SEO_FOOTER, label: resourceId });
  }, []);
  return (
    <li>
      <TextButton as="a" href={`${pathsManifest.MarketTrendsPage}/${resourceId}/`} fontType="body" onClick={onClick}>
        {name}
      </TextButton>
    </li>
  );
};

const SEOFooter: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<SEOFooterProps>>> = (
  props,
) => {
  const { areaName, zipcodesInCity, nearbyAreas } = props;
  return (
    <Card marginTop="md" paddingX="md" paddingBottom="xl" cardType="secondary">
      {nearbyAreas.length ? (
        <Spacer paddingTop="sm" marginBottom="sm">
          <Heading level={6} as="h4" marginBottom="lg">
            Nearby areas
          </Heading>
          <S.FlexList>
            {nearbyAreas.map(({ name, resourceId }) => (
              <Link key={resourceId} name={name} resourceId={resourceId} />
            ))}
          </S.FlexList>
        </Spacer>
      ) : null}
      {zipcodesInCity.length ? (
        <Spacer paddingTop="sm">
          <Heading level={6} as="h4" marginBottom="lg">
            Zip codes in {areaName}
          </Heading>
          <S.FlexList>
            {zipcodesInCity.map(({ name, resourceId }) => (
              <Link key={resourceId} name={name} resourceId={resourceId} />
            ))}
          </S.FlexList>
        </Spacer>
      ) : null}
    </Card>
  );
};

export default SEOFooter;
